/**
 * Слой отделки стен: что лежит на каждой стороне каждой стены — краска, обои, штукатурка.
 *
 * Ключ — сторона стены (`wallFaceKey`), а не комната: id комнаты собирается из её углов
 * и меняется от любого нового узла, а сторона стены живёт, пока жива стена. Кнопка
 * «на всю комнату» просто передаёт сюда все стороны комнаты разом. Когда стену режут
 * Т-стыком, отделку на половинки переносит `splitWallAt`, при удалении стены — `removeWall`.
 */
import { create } from "zustand";
import { wallFaceKey, type WallFace, type WallFinish } from "@/shared/plan";

interface WallFinishLayerState {
	items: Record<string, WallFinish>;
	visible: boolean;

	/** Назначить отделку сторонам; цвет, выбранный раньше, при смене отделки сбрасывается */
	setFinish: (faces: WallFace[], finish: string) => void;
	/** Свой цвет сторонам; undefined — вернуть цвет из каталога */
	setFinishColor: (faces: WallFace[], color: string | undefined) => void;
	removeFinish: (faces: WallFace[]) => void;

	setVisible: (visible: boolean) => void;
	toggleVisible: () => void;

	restoreFinishes: (items: Record<string, WallFinish>) => void;
}

export const useWallFinishStore = create<WallFinishLayerState>((set) => ({
	items: {},
	visible: true,

	setFinish: (faces, finish) =>
		set((s) => {
			const items = { ...s.items };
			for (const { wallId, side } of faces) {
				const id = wallFaceKey(wallId, side);
				if (items[id]?.finish === finish) continue;
				items[id] = { id, wallId, side, finish };
			}
			return { items, visible: true };
		}),

	setFinishColor: (faces, color) =>
		set((s) => {
			const items = { ...s.items };
			for (const { wallId, side } of faces) {
				const id = wallFaceKey(wallId, side);
				const current = items[id];
				if (!current) continue;
				const next = { ...current, color };
				if (color === undefined) delete next.color;
				items[id] = next;
			}
			return { items };
		}),

	removeFinish: (faces) =>
		set((s) => {
			const items = { ...s.items };
			for (const { wallId, side } of faces) delete items[wallFaceKey(wallId, side)];
			return { items };
		}),

	setVisible: (visible) => set({ visible }),
	toggleVisible: () => set((s) => ({ visible: !s.visible })),

	restoreFinishes: (items) => set({ items }),
}));
